<template>
  <div class="component-container">
    <div class="title-container" v-if="title">
      <span class="title-text">Detalles del saldo</span>
    </div>
    <b-row v-bind:class="{ 'cells-container': border, 'cells-container-no-border': !border }">
      <div v-for="item of items" :key="item.label">
        <div class="cell row">
          <div class="d-lg-table-cell">
            <div class="cell-title">
              <span class="cell-title-text">{{ item.label }}</span>
            </div>
            <div class="cell-body">
              <span class="cell-body-text">{{ item.text }}</span>
            </div>
          </div>
          <span v-if="item !== items[items.length - 1]" class="cell-divisor"></span>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script lang="ts">
import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export default class PInfoBar extends Vue {
  @Prop({ required: false, default: null })
  title!: string;
  @Prop({ required: false, default: true })
  border!: boolean;
  @Prop({
    required: true,
    default: [
      { label: "Código cliente", text: "5-000" },
      { label: "Delegación", text: "Rio Grande" },
      { label: "Fecha certificado", text: "01/03/2020" },
      { label: "Divisa", text: "ARS" },
      { label: "Saldo actual", text: "1.000.000.000,00" },
      { label: "saldo anterior", text: "1.000.000.000,00" },
      { label: "entradas", text: "1.000.000.000,00" },
      { label: "salidas", text: "1.000.000.000,00" },
    ],
  })
  items!: { label: string; text: string }[];
}
</script>

<style lang="scss" scoped>
.component-container {
  padding: 0.5rem;
}

.cell-divisor {
  width: 1px;
  border: solid 1px #e9e9e9;
  margin-left: 1rem;
}

.cells-container {
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
}
.cells-container-no-border {
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
}

.title-text {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #808080;
}

.cell-title-text {
  font-size: 12px;
  color: #979797;
}

.cell-title-text::first-letter {
  text-transform: uppercase;
}

.cell-body {
  margin-top: -0.4rem; //TODO: resolver de otra manera
}

.cell-body-text {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #808080;
  vertical-align: top;
}

.cell-body-text::first-letter {
  text-transform: uppercase;
}

.cell {
  min-width: 5rem;
  padding-left: 1rem;
  justify-content: space-between;
  padding-right: 2rem;
}
</style>
